<template>
  <div class="candidate navigation-bar">
    <v-menu :close-on-content-click="false" open-on-hover offset-y bottom left>
      <v-btn slot="activator" icon>
        <v-badge right overlap
          v-if="notifications"
          :value="notifications && notifications.length > 0"
          :color="themes.candidate.light.primary"
          class="badge--xs"
        >
          <span slot="badge" v-if="sortedNotifications[0]" class="caption">
            {{ sortedNotifications.length }}
          </span>
          <v-icon :color="themes.candidate.light.muted">mdi-bell-ring</v-icon>
        </v-badge>
      </v-btn>
      <v-card>
        <v-card-title :class="themes.candidate.light.dialogTitle">Notifications</v-card-title>
        <v-list avatar two-line dense
          style="max-width: 400px; max-height: 400px; overflow-y: scroll;"
        >
          <v-list-tile
            v-for="(notification, i) in sortedNotifications" :key="`notification-${i}`"
            @click="handleNotification(notification)"
          >
            <v-list-tile-avatar>
              <img :src="notification.image" />
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>
                <v-tooltip top>
                  <span slot="activator">{{ notification.description }}</span>
                  {{ notification.description }}
                </v-tooltip>
              </v-list-tile-title>
              <v-list-tile-sub-title>
                <v-icon small left>mdi-calendar-today</v-icon>
                {{ notification.notifiedAt | inWords({ addSuffix: true }) }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action v-if="notification.type !== 'message'">
              <v-list-tile-action-text>
                <v-tooltip top>
                  <v-btn flat icon
                    slot="activator"
                    @click="dismissNotification(notification)"
                    :color="themes.candidate.light.accent"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                  Dismiss notification
                </v-tooltip>
              </v-list-tile-action-text>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile v-if="!sortedNotifications[0]">
            <v-list-tile-content>
              <v-list-tile-title>No new notifications</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-list-tile-action-text>
                <v-icon :class="themes.candidate.light.accent">mdi-check-all</v-icon>
              </v-list-tile-action-text>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-menu>

    <v-menu open-on-hover bottom left offset-y>
      <v-btn slot="activator" icon>
        <v-badge right overlap
          v-if="actions"
          :value="actions && actions.length > 0"
          :color="themes.candidate.light.primary"
          class="badge--xs"
        >
          <span slot="badge" class="caption">{{ actions.length }}</span>
          <v-icon :color="themes.candidate.light.muted">mdi-format-list-checkbox</v-icon>
        </v-badge>
      </v-btn>
      <ActionItems />
    </v-menu>
  </div>
</template>

<script>
// Components
import ActionItems from '@/components/candidate/ActionItems'

// Helpers
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'CandidateNavigationBar',
  components: { ActionItems },

  created() {
    this.$store.dispatch('candidate/notifications/fetchAll')
    this.$store.dispatch('candidate/actionItems/fetchAll')
  },

  computed: {
    ...mapGetters({
      actions: 'candidate/actionItems/all',
      profile: 'candidate/profile/model',
      user: 'auth/user',
    }),

    ...mapState('candidate/notifications', { notifications: 'all' }),

    sortedNotifications() {
      if (!this.notifications) return []

      const notifications = JSON.parse(JSON.stringify(this.notifications))
      return notifications.sort(({ notifiedAt: a }, { notifiedAt: b }) => {
        if (new Date(a) > new Date(b)) return -1
        if (new Date(a) < new Date(b)) return 1
        return 0
      })
    },
  },

  methods: {
    handleNotification(notification) {
      if (notification.type === 'message') {
        this.$router.push('/candidate/messages')
      }
    },
    dismissNotification(notification) {
      this.notifications.splice(this.notifications.indexOf(notification), 1)
      this.$store.dispatch('candidate/notifications/dismiss', notification).then(
        () => {
          this.$store.dispatch('candidate/notifications/fetchAll')
        },
        errors => this.$store.dispatch('snackbarError', 'Error: Was not dismissed')
      )
    },
  },
}
</script>

<style lang="scss">
.candidate.navigation-bar {
  .badge--xs {
    .v-badge__badge {
      width: 18px;
      height: 18px;
    }
  }
}
.toolbar__title img {
  margin-top: 8px;
}

.settings {
  position: absolute;
  opacity: 0;
}

.settings:hover {
  opacity: 1;
}
</style>
